var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "#77A600"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.387 9H12.4C11.63 9 11 9.62308 11 10.3846V25.6154C11 26.3769 11.63 27 12.4 27H23.6C24.37 27 25 26.3769 25 25.6154V13.5554L20.387 9ZM21.85 22.8462H14.15C13.954 22.8462 13.8 22.6938 13.8 22.5C13.8 22.3062 13.954 22.1538 14.15 22.1538H21.85C22.046 22.1538 22.2 22.3062 22.2 22.5C22.2 22.6938 22.046 22.8462 21.85 22.8462ZM21.85 20.7692H14.15C13.954 20.7692 13.8 20.6169 13.8 20.4231C13.8 20.2292 13.954 20.0769 14.15 20.0769H21.85C22.046 20.0769 22.2 20.2292 22.2 20.4231C22.2 20.6169 22.046 20.7692 21.85 20.7692ZM22.2 18.3849C22.2 18.5566 22.046 18.6923 21.85 18.6923H14.15C13.954 18.6923 13.8 18.5566 13.8 18.3849V16.2318C13.8 16.0588 13.954 15.9231 14.15 15.9231H21.85C22.046 15.9231 22.2 16.0588 22.2 16.2305V18.3849ZM21.5 13.8462C21.1287 13.8462 20.7726 13.7003 20.5101 13.4406C20.2475 13.1809 20.1 12.8288 20.1 12.4615V9.69231L24.3 13.8462H21.5Z",
    fill: "#77A600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.b4a958cf9445ce3159bc308f9685ce60.svg";
export { ForwardRef as ReactComponent };